import axios from 'axios';

import { config } from '../../config';
import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useParameterStore from '../parameterStore/useParameterStore';
import useSignOutStore from '../signOutStore/useSignOutStore';
import { apiStore } from './apiStore';

const useApiStore = createStore({
  creator: apiStore({
    config,
    httpClient: axios,
    useParameterStore: lazyDependency(() => useParameterStore),
    useSignOutStore: lazyDependency(() => useSignOutStore),
  }),
  id: 'api',
  middlewares: {
    devtools: true,
  },
});

export default useApiStore;
